function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "currentColor",
  className: "leaf",
  d: "M115.343,123.839c0.814,1.256,3.343,2.605,7.23,4.014c7.586-1.069,14.943-1.586,21.885-1.586 c15.579,0,30.166,2.469,42.438,7.145c17.87-5.567,43.412-11.694,69.108-11.694c25.694,0,51.228,6.126,69.108,11.694 c12.262-4.676,26.848-7.145,42.42-7.145c7.001,0,14.418,0.518,22.063,1.604c3.471-1.341,6.296-2.699,8.325-4.031 c42.2-28.139,53.036-81.183,47.41-69.931c-4.218,8.418-60.309,35.581-100.004,52.222c14.68-17.769,31.677-44.134,43.438-80.309 c0,0-60.978,52.382-98.867,74.887c-11.974-20.816-33.892-86.589-33.892-86.589s-18.567,49.515-20.358,81.412 c-30.21-16.929-63.354-51.474-72.485-74.538c-10.752-27.189-13.78,53.545,15.436,89.396c-1.095,0.162-2.206,0.315-3.344,0.476 c-39.111-16.072-100.454-47.91-104.926-54.86C64.708,47.255,73.143,101.954,115.343,123.839z M290.531,107.181l0.747,0.857 l-3.098-0.746L290.531,107.181z"
}), React.createElement("path", {
  fill: "currentColor",
  className: "tomato",
  d: "M485.83,198.564c-38.169-57.253-117.544-70.584-160.338-52.195c-18.27-5.906-43.872-12.27-69.49-12.27 c-25.619,0-51.228,6.364-69.499,12.27c-42.794-18.388-122.168-5.058-160.338,52.195c-64.136,96.203-18.711,299.318,229.836,299.318 C504.541,497.882,549.974,294.767,485.83,198.564z M101.172,262.929c-17.099,0-30.947-13.857-30.947-30.948 c0-17.09,13.848-30.947,30.947-30.947c17.082,0,30.947,13.857,30.947,30.947C132.119,249.071,118.253,262.929,101.172,262.929z"
}));

var SvgTomato = function SvgTomato(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "_x32_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTomato, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tomato.998f40c5.svg";
export { ForwardRef as ReactComponent };